/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Routes for the application

Author: Deimos Space UK

Version: 1.0
*/

import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import Layout from "../core/components/content/Layouts";
import CapacityEvaluation from "../views/capacity-evaluation/container/CapacityEvaluation";
import ImpactEvaluation from "../views/impact-evaluation/container/ImpactEvaluation";
import ExistingMissions from "../views/missions/existing-missions/container/ExistingMissions";
import InputView from "../views/input-view/container/InputView";
import PlannedMissions from "../views/missions/planned-missions/container/PlannedMission";
import MissionDetail from "../views/missions/mission-detail/container/MissionDetail";
import Login from "../views/login/container/Login";
import Proccesing from "../views/processing";
import Landing from "../views/landing/Landing";
import LandingOut from "../views/landing/LandingOut";
import Tos from "../views/landing/Tos";
import Policy from "../views/landing/Policy";
import { useEffect, useState } from "react";
import { getPetition } from "../api/api";
function Redirect(props) {
	return <Navigate to={props.path} />;
}

export default function Roots() {
	// const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const userSession = sessionStorage.getItem('user');
	const [cookies] = useCookies(['TosAccepted'])
	const [showTos, setShowTos] = useState(true);

	useEffect(() => {
		
		// get info from https://mise-vm02.deimos-space.com/api/userinfo
		// set user info in sesion storag
		if (!userSession) {
			setLoading(true);
			fetch(process.env.REACT_APP_SERVER_URL+'/api/userinfo', {
				credentials: 'include',
			})
				.then(response => response.json())
				.then(data => {
					sessionStorage.setItem('user', JSON.stringify(data))
					setLoading(false);
				})
				.catch((error) => {
					console.error('Error:', error);
					setLoading(false);
				});
		}
	}, [userSession])

	useEffect(() => {
		if (cookies.TosAccepted) {
			setShowTos(false);
		}
		else {
			setShowTos(true);
		}
	}, [cookies])

	if (userSession) {
		return (
			<BrowserRouter>
				<Layout>
					<Routes>
						<Route path="/" element={<Landing />} />
						<Route
							path="/capacity-evaluation"
							element={<CapacityEvaluation />}
						/>
						<Route path="/existing-missions" element={<ExistingMissions />} />
						<Route path="/planned-missions" element={<PlannedMissions />} />
						<Route path="/impact-evaluation/input" element={<InputView />} />
						<Route path="/impact-evaluation/clone/:id" element={<InputView />} />
						<Route path="/impact-evaluation/output/:id" element={<ImpactEvaluation />} />
						<Route path="/mission-detail/:id" element={<MissionDetail />} />
						<Route path="/impact-evaluation/loading/:missionId/:taskId" exact={true} element={<Proccesing />} />
						<Route path="*" exact={true} element={<Redirect path={"/"} />} />
					</Routes>
				</Layout>
			</BrowserRouter>
		);
	} else if (showTos) {
		return (
			<BrowserRouter>
				<Routes>
					<Route path="/landing-login" element={<>
						<Tos />
						<Policy />
					</>}/>
					<Route path="*" element={<Redirect path={"/landing-login"} />}/>
				</Routes>
			</BrowserRouter>

		)
	} else if (!loading) {
		return (
			<BrowserRouter>
				<Routes>
					<Route path="/login" exact={true} element={<Login />} />
					<Route path="/tos" exact={true} element={<Tos />} />
					<Route path="/policy" exact={true} element={<Policy />} />
					<Route path="/landing-login" exact={true} element={<LandingOut/>} />
					<Route path="*" exact={true} element={<Redirect path={"/landing-login"} />} />
				</Routes>
			</BrowserRouter>
		);
	}
	else {
		return (
			<></>
		)
	}
}
